export default {"src":"/_next/static/media/bottle.89b736a7.svg","height":266,"width":224,"blurWidth":0,"blurHeight":0};